export function projectFilter(root = document) {
    const filters = root.querySelectorAll('[data-filter]');

    if (!filters.length) return;

    filters.forEach(filter => {
        filter.addEventListener('click', () => {
            const projects = root.querySelectorAll('.project-archive .project-card');
            const category = filter.dataset.filter;
            const isActive = !filter.classList.contains('is-active');

            filters.forEach(item => {
                item.classList.remove('is-active');
                item.setAttribute('aria-pressed', 'false');
            });

            if (isActive) {
                filter.classList.add('is-active');
                filter.setAttribute('aria-pressed', 'true');
            }

            const visibleProjects = [];

            projects.forEach(project => {
                const categories = project.dataset.categories?.split(' ') || [];
                const show = !isActive || categories.includes(category);

                if (show) visibleProjects.push(project);
            });

            gsap.to(projects, {
                autoAlpha: 0,
                y: 20,
                scale: 0.98,
                duration: 0.25,
                ease: 'power2.out',
                stagger: 0.02,
                onComplete: () => {
                    projects.forEach(project => {
                        project.hidden = !visibleProjects.includes(project);
                    });

                    gsap.set(visibleProjects, {
                        autoAlpha: 0,
                        y: 30,
                        scale: 0.98
                    });

                    gsap.to(visibleProjects, {
                        autoAlpha: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.6,
                        stagger: 0.07,
                        ease: 'power4.out',
                        clearProps: 'opacity,visibility,transform'
                    });

                    ScrollTrigger.refresh();
                }
            });
        });
    });
}
